import axios from "axios";

const BASE_URL = `https://api.hacktonomy.com/api/`;
//const BASE_URL = `https://api.hacktonomy.com/api/`;

const Axios = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
   withCredentials: true,
});


// Axios.interceptors.request.use((config) => {
//   const token = localStorage.getItem("hcasp_token");
//   if (token) {
//     config.headers.Authorization = `Bearer ${token}`;
//   }
//   return config;
// });

// ---------- AUTH APIs ----------

export const REGISTER_API = async (body) => {
  try {
    const response = await Axios.post("auth/register", body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const REGISTER_CREATE_ORDER = async (body) => {
  try {
    const response = await Axios.post("auth/register/create-order", body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


// export const LOGIN_API = async (body) => {
//   try {
//     const response = await Axios.get("auth/login",  body, { withCredentials: true });
//     return response;
//   } catch (error) {
//     console.error(error);
//     throw error;
//   }
// };

export const LOGIN_API = async (body) => {
  try {
    const response = await Axios.post("auth/login", body, { withCredentials: true });
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const GET_ME_API = async () => {
  try {
    const response = await Axios.get("auth/me");
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const LOGOUT_API = async () => {
  try {
    const response = await Axios.get("auth/logout");
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const AUTH_CONFIRM = async (token) => {
  try {
    const response = await Axios.get(`auth/verify?token=${token}`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const REGISTER_VERIFY = async (body) => {
  try {
    const response = await Axios.post("auth/register/verify", body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const RESEND_CONFIRM = async () => {
  try {
    const response = await Axios.post("auth/resend-confirmation");
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const FORGOT_PASSWORD = async (body) => {
  try {
    const response = await Axios.post("auth/forgot-password",body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const RESET_PASSWORD = async (body) => {
  try {
    const response = await Axios.post("auth/reset-password", body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const PRICING = async () => {
  try {
    const response = await Axios.get("pricing");
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const SLOTS = async () => {
  try {
    const response = await Axios.get("slots");
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const DASHBOARD_ENROLL = async (body) => {
  try {
    const response = await Axios.post("dashboard/enroll", body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const VERIFY_PAYMENT_API = async (body) => {
  try {
    const response = await Axios.post("payment/verify", body);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GST_DETAILS = async (body) => {
  try {
    const response = await Axios.post("gst-detail/",body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const GET_INVOICE_DETAIL = async (token) => {
  try {
    const response = await Axios.get(`get-invoice-details?token=${token}`);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const EDIT_USER = async (body) => {
  try {
    const response = await Axios.post("edit-profile",body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const APPLY_COUPON = async (body) => {
  try {
    const response = await Axios.post("apply-coupon",body);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default Axios;




